exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".otp-input{width:40px;height:40px;font-size:20px}[dir] .otp-input{padding:5px;margin:0 10px;border-radius:4px;border:1px solid rgba(0,0,0,.3);text-align:center}@media (max-width:1200px){.otp-input{font-size:15px}[dir] .otp-input{padding:5px;margin:0}}.otp-input::-webkit-inner-spin-button,.otp-input::-webkit-outer-spin-button{-webkit-appearance:none}[dir] .otp-input::-webkit-inner-spin-button,[dir] .otp-input::-webkit-outer-spin-button{margin:0}", ""]);

// exports
